module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-Scholarship-Benchmark-Test-Banner-0cd5a51a85c367754e3e80150fbf85a0.jpg";